

<div class="slider banner_slider_loader notLoggedIn pnp-loader" *ngIf="isLoading">
  <div class="loader">
    <div class="loader-inner"></div>
  </div>
</div>
<div class="zimpler_deposit" *ngIf="!isLoading">
  <img class="zimpler_deposit--top_icon" src="{{siteUrlPath +'/'+ mediaPath +'/icon-1000-games_'+ langCode +'.webp'}}" alt="1000+ games"/>
  <div class="zimpler_deposit--heading">
    <h1 class="hide-below-992">{{'quickDeposit.feelinglucky' | translate }}</h1>
    <h1 class="show-below-992">{{'quickDeposit.playinstantly' | translate }}</h1>

    <p class="hide-below-992">
      <span>{{'quickDeposit.gamesAvailable1' | translate}} {{'quickDeposit.gamesAvailable2' | translate}}</span>
      <i class="icon icon-heart"></i>
      <span>{{'quickDeposit.fastWithdrawals1' | translate}} {{'quickDeposit.fastWithdrawals2' | translate}}</span>
    </p>
    <p class="show-below-992">{{'quickDeposit.uptocashback' | translate}}</p>
  </div>
  <div class="zimpler_deposit--form" [formGroup]="zimplerQuickDepositForm">
    <div class="zimpler_deposit--amount">
      <ng-container *ngIf="!addBonus">
        <div *ngFor='let amount of predefineAmounts' class="zimpler_deposit--item"
          (click)="setTransactionAmount(amount)" [ngClass]="depositAmount === amount ? 'active':''">
          {{getValueForTab(amount)}}
        </div>
      </ng-container>

      <div class="zimpler_deposit--otheramount">
        <div class="controls">
          <span class="currency_symbol" [ngClass]="otherAmount || showCurrencySymbol ? 'visible' : 'hidden'"
              [innerHTML]="currencySymbol"></span>
          <input type="tel" name="amount" id="amount" class="floatLabel form-control" value={{otherAmount}}
          (keypress)="numberOnly($event)" (input)="onChangeEvent($event)"
          (focus)="onFocus()" (focusout)="onFocusOut()"
          autocomplete="off" />
          <label for="amount">{{'quickDeposit.otheramount' | translate }}</label>
        </div>
      </div>
    </div>

    <button *ngIf="!addBonus" class="zimpler_deposit--btn site-btn" [disabled]="amountInvalid"
      (click)="quickDeposit()">
      <span class="depSpan hide-below-992">{{'quickDeposit.playInstantly' | translate }}</span>
      <span class="noRegSpan hide-below-992">{{'payandplayStep1.noregistrationneeded' | translate}}</span>
      <span class="show-below-992">{{'quickDeposit.playInstantly' | translate }}</span>
      <span class="noRegSpan show-below-992">{{'payandplayStep1.noregistrationneeded' | translate}}</span>

    </button>
    <div class="zimpler_deposit--desc ">
      <p class="hide-npn">
        <img src="{{siteUrlPath +'/'+ mediaPath +'/icon-ssl-secure.png'}}"  alt="ssl secure"/>
        <span class="zimpler_deposit--desc_left-content">{{'quickDeposit.sslsecure' | translate}}</span>
      
        <img src="{{siteUrlPath +'/'+ mediaPath +'/icon-ssl-secure.png'}}" alt="easy to use"/>
        <span>{{'quickDeposit.easytouse' | translate}}</span>
      </p>
      <p class="terms-info" *ngIf="byclickingDesposit" [innerHTML]="byclickingDesposit | safeHtml"></p>
    </div>
    <!-- <div class="zimpler_deposit--desc show-below-992">
      <p>
        <img src="{{siteUrlPath +'/'+ mediaPath +'/icon-games.png'}}"  alt="Games Available" width="45px" height="45px"/>
        <span class="zimpler_deposit--desc_left-content">{{'quickDeposit.gamesAvailable1' | translate}} {{'quickDeposit.gamesAvailable2' | translate}}</span>
      
        <img src="{{siteUrlPath +'/'+ mediaPath +'/icon-withdraw.png'}}" alt="Fast withdrawal" width="45px" height="45px"/>
        <span>{{'quickDeposit.fastWithdrawals1' | translate}} {{'quickDeposit.fastWithdrawals2' | translate}}</span>
      </p>
    </div> -->
  </div>
</div>